import { createBrowserHistory } from 'history'
import { applyMiddleware, compose, createStore } from 'redux'
import { routerMiddleware } from 'connected-react-router'
import { loadUser } from 'redux-oidc'
import createRootReducer from './reducers'
import userManager from '../utils/userManager'
import apiMiddleware from './middleware/api'

export const history = createBrowserHistory()

export default function configureStore(preloadedState) {
  const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  
  const store = createStore(
    createRootReducer(history),
    preloadedState,
    composeEnhancer(
      applyMiddleware(
        routerMiddleware(history),
        apiMiddleware
      )
    )
  )
  
  loadUser(store, userManager)
  
  return store
}